/** Normalizuje postup receptu na pole neprázdných kroků (stejná logika jako na API). */
export function normalizeRecipeSteps(input: unknown): string[] {
  if (Array.isArray(input)) {
    const out: string[] = [];
    for (const v of input) {
      if (typeof v === "string") {
        const t = v.trim();
        if (t) out.push(t);
      }
    }
    return out;
  }
  if (typeof input === "string") {
    const t = input.trim();
    if (!t) return [];
    if (t.startsWith("[")) {
      try {
        return normalizeRecipeSteps(JSON.parse(t));
      } catch {
        /* pokračuj jako plain text */
      }
    }
    return t
      .split(/\r?\n+/)
      .map((line) => line.replace(/^\s*\d+[\.\)]\s*/, "").trim())
      .filter(Boolean);
  }
  return [];
}
